import { render, staticRenderFns } from "./index_h5.vue?vue&type=template&id=a3e46f98&scoped=true&"
import script from "./index_h5.vue?vue&type=script&lang=js&"
export * from "./index_h5.vue?vue&type=script&lang=js&"
import style0 from "./index_h5.vue?vue&type=style&index=0&id=a3e46f98&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3e46f98",
  null
  
)

export default component.exports